import tagularModule from 'js/store/helpers/tagular.js'
import tagularAuthenticatedModule from 'js/store/helpers/tagular-authenticated.js'

const formType = 'CONTACT'
const stepType = 'CONFIRMATION'
const stepName = 'Verify_Identity_Emailonly'

/**
 * This event fires when an OIM form becomes visible on the screen
 */
document.addEventListener('om.Campaign.load', function(event) {
  const eventDetails = event.detail.Campaign
  const formName = eventDetails.data.name
  const formContainer = eventDetails.contain
  const formId = formContainer && formContainer.id ? formContainer.id : null

  tagularModule.formViewed(formType, formName, formId)
})

/**
 * This event fires when an OIM form submit button is clicked
 */
document.addEventListener('om.Optin.init.submit', function(event) {
  const eventDetails = event.detail.Campaign
  const formName = eventDetails.data.name
  const formContainer = eventDetails.contain
  const formId = formContainer && formContainer.id ? formContainer.id : null
  const formFields = eventDetails.Form.inputs.map(input => {
    const labels = [...input.labels]

    return {
      fieldId: input.id,
      fieldLabel: labels.length ? labels[0].innerText : '',
      fieldName: input.name,
      fieldType: input.type,
      fieldValue: input.value
    }
  })

  tagularModule.formSubmitted(formId, formName, formFields, formType)
})

/**
 * This event fires when an OIM form submit is successful
 */
document.addEventListener('om.Optin.success', function(event) {
  const eventDetails = event.detail.Campaign
  const formName = eventDetails.data.name
  const formContainer = eventDetails.contain
  const formId = formContainer && formContainer.id ? formContainer.id : null
  const stepId = window.purchaseId
  const email = event.detail.Optin.data.fields.email
  const body = { email }

  const anonymousId =
    window._Tagular &&
    window._Tagular.webContext &&
    window._Tagular.webContext.anonymousId

  if (anonymousId) {
    body['anonymousId'] = anonymousId
  }

  //Post to Deposits OIM webhook to create a new bedrock user
  fetch(`${process.env.DEPOSITS_OIM_WEBHOOK_URL}/createUser`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
    .then(() => {
      tagularAuthenticatedModule.formOutcomeReceived(
        formType,
        formName,
        formId,
        stepName,
        stepType,
        stepId
      )
    })
    .catch(error => {
      console.error('Error:', error)
    })
})

/**
 * This event fires when an OIM form submit fails
 */
document.addEventListener('om.Optin.error', function(event) {
  const eventDetails = event.detail.Campaign
  const formName = eventDetails.data.name
  const formContainer = eventDetails.contain
  const formId = formContainer && formContainer.id ? formContainer.id : null
  const stepId = window.purchaseId

  tagularAuthenticatedModule.formErrored(
    formType,
    formName,
    formId,
    stepName,
    stepType,
    stepId
  )
})
